import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-required-label',
  templateUrl: './required-label.component.html',
  styleUrls: ['./required-label.component.css']
})
export class RequiredLabelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
